import { ECOMemberPassIntegrationState } from './partials/eco-member-pass'
import { ECOPortalIntegrationState } from './partials/eco-portal'
import { OWRIntegrationState } from './partials/owr'
import { SignupIntegrationState } from './partials/signup'
import { TmetricState } from './partials/tmetric'

export const IntegrationState = _ => ({
  ...ECOMemberPassIntegrationState,
  ...ECOPortalIntegrationState,
  ...OWRIntegrationState,
  ...SignupIntegrationState,
  ...TmetricState,
})
